<div class="srm-overlay" (click)="onCancel()">
  <div class="srm-modal" (click)="$event.stopPropagation()">
    <header class="srm-head">
      <div class="srm-head-titleblock">
        <h2 class="srm-title">Access Group</h2>
        <p class="srm-sub">Apply a reusable bundle of events and plans</p>
      </div>
      <button type="button" class="srm-close" (click)="onCancel()" aria-label="Close">×</button>
    </header>

    <div class="srm-body">
      <div class="srm-toolbar">
        <input type="text" class="srm-search" placeholder="Search access groups…"
               [(ngModel)]="searchText" style="flex:1" />
        <button type="button" class="srm-link-btn" (click)="onManageGroups()">+ Define your own</button>
      </div>

      <div class="srm-list">
        <div class="srm-list-scroll">
          <label class="srm-list-row"
                 *ngFor="let group of filteredGroups(); trackBy: trackGroup"
                 [class.srm-list-row--selected]="selectedGroupId === group.id">
            <input type="radio" name="accessGroup"
                   [checked]="selectedGroupId === group.id"
                   (change)="select(group)" />
            <span class="srm-row-name">{{ group.name }}</span>
            <span class="srm-row-meta">{{ group.items.length }} item{{ group.items.length === 1 ? '' : 's' }}</span>
          </label>
          <div class="srm-empty" *ngIf="!filteredGroups().length">
            No access groups defined yet. Use “Define your own” to create one.
          </div>
        </div>
      </div>
    </div>

    <footer class="srm-foot">
      <button type="button" class="srm-btn srm-btn-cancel" (click)="onCancel()">Cancel</button>
      <button type="button" class="srm-btn srm-btn-save"
              [disabled]="!selectedGroupId" (click)="onConfirm()">Save rule</button>
    </footer>
  </div>
</div>
